import React from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";
import RequestedTransferItem from "./RequestedTransferItem";
import { getRequestedStatusString } from "../../helpers/transferScheduleHelpers";
import { makeStyles } from "@material-ui/core/styles";

const RequestedTable = ({ transfers, updatedTransfers, wardMode, showAdHocRequestModal, setIsRequestedItemDragging, setDraggingItemName,roles,selectedLocationId,setWardMode }: any) => {
  const classes = useStyles();
  const { authStore } = useSelector((state: RootState) => state);
  const currentUserWard = authStore.data?.ward;

  React.useEffect(() => {
    if(transfers?.length>0 && (currentUserWard != null && currentUserWard !='' && currentUserWard != undefined)){
      setWardMode(1);
    }
  
    return () => {
      setWardMode(0);
    }
  }, [transfers,currentUserWard])
  

  return (
    <div className={classes.root}>
      <div className={classes.table}>
        <div className={classes.tableHead}>
          <div className={classes.multiLoadColumn}></div>
          <div className={classes.pickupTimeColumn}>Submitted</div>
          <div className={classes.patientColumn}>Patient</div>
          <div className={classes.needsColumn}>Needs</div>
          <div className={classes.fromColumn}>From</div>
          <div className={classes.toColumn}>To</div>
          <div className={classes.priorityColumn}>Pri</div>
          <div className={classes.statusColumn}>Status</div>
          <div className={classes.actionButtonColumn}></div>
        </div>

        {transfers.map((row: any, index: number) => {       
          if (wardMode == 1 &&  row.originWardId != authStore.data?.ward && row.destinationWardId != authStore.data?.ward) return null;
          // if(row.patientOfLocation == selectedLocationId ) {       
          return (
            <RequestedTransferItem
              key={row.transferId}
              transferRequest={row}
              updatedTransfers={updatedTransfers}
              getRequestedStatusString={getRequestedStatusString}
              showAdHocRequestModal={showAdHocRequestModal}
              setIsRequestedItemDragging={setIsRequestedItemDragging}
              setDraggingItemName={setDraggingItemName}
              roles={roles}
            />                   
          );   
        //  }             
        })}
        {transfers.length === 0 && <div className={classes.noTransfersText}>No Records Found</div>}
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  root: {},
  table: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    // maxHeight: "280px",
    overflowY: "auto",
  },
  tableHead: {
    height: 43,
    minHeight: 43,
    maxHeight: 43,
    backgroundColor: "#012756",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "22px",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    borderTop: "1px solid #00152E",

    "& > div": {
      color: "rgba(255, 255, 255, 0.3)",
    },
  },
  tableRow: {
    display: "flex",
    alignItems: "center",
    color: "#FFFFFF",
    fontWeight: 500,
    backgroundColor: "rgb(2, 72, 157, 0.23)",
    height: 45,
    minHeight: 45,
    maxHeight: 45,
    fontSize: "18px",
    lineHeight: "22px",
    borderTop: "1px solid #00152E",
    cursor: "pointer",

    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
    },

    "&:not(:last-child)": {
      borderBottom: "1px solid #00152E",
    },
  },
  tableCell: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    height: 33,
  },
  animatedUpdatedItem: {
    animation: `$updatedTransferEffect 60000ms ease-out`,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08) !important",
    },
  },
  "@keyframes updatedTransferEffect": {
    "0%": { backgroundColor: "#F4B8273A" },
    "100%": { backgroundColor: "#002047" },
  },
  multiLoadColumn: {
    flex: "0 0 53px",
    display: "flex",
    justifyContent: "center",
    height: "100%",
  },
  patientColumn: {
    paddingLeft: 10,
    flex: "1 1 169px",
    display: "flex",

    "& span": {
      color: "#010B18",
      opacity: "0.39",
    },

    "@media (max-width: 1280px)": {
      display: "none",
    },
  },
  pickupTimeColumn: {
    paddingLeft: 15,
    flex: "0 0 171px",
  },
  needsColumn: {
    paddingLeft: 15,
    flex: "0 0 164px",
    display: "flex",
    alignItems: "center",

    "& img": {
      width: 18,
      height: 18,
    },
    "@media (max-width: 1280px)": {
      display: "none",
    },
  },
  fromColumn: {
    paddingLeft: 15,
    flex: "1 1 248px",
    display: "block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  toColumn: {
    paddingLeft: 15,
    flex: "1 1 248px",
    display: "block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  priorityColumn: {
    flex: "0 0 47px",
  },
  statusColumn: {
    flex: "1 1 245px",
  },
  actionButtonColumn: {
    paddingLeft: 15,
    paddingRight: 10,
    flex: "0 0 32px",
    display: "flex",
    justifyContent: "flex-end",
  },
  noTransfersText: {
    display: "flex",
    justifyContent: "center",
    fontWeight: 500,
    backgroundColor: "rgb(2, 72, 157, 0.23)",
    height: 55,
    fontSize: "18px",
    lineHeight: "22px",
    alignItems: "center",
  },
  checkboxes: {
    padding: 0,
    margin: 0,
  },
  yellowBoxText: {
    background: "#F4B827",
    padding: "6px 16px",
    fontSize: 14,
    fontWeight: 700,
    color: "#03090E",
    borderRadius: 4,
    marginLeft: 5,
    cursor: "pointer",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  groupStart: {
    backgroundColor: "transparent",
    width: "10px",
    height: "20px",
    borderTop: "2px solid #fff",
    borderLeft: "2px solid #fff",
    alignSelf: "flex-end",
  },
  groupMiddle: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  groupMidTop: {
    backgroundColor: "transparent",
    width: "10px",
    height: "21px",
    borderLeft: "2px solid #fff",
  },
  groupMidBottom: {
    backgroundColor: "transparent",
    width: "10px",
    height: "21px",
    borderTop: "2px solid #fff",
    borderLeft: "2px solid #fff",
  },
  groupEnd: {
    backgroundColor: "transparent",
    width: "10px",
    height: "20px",
    borderBottom: "2px solid #fff",
    borderLeft: "2px solid #fff",
    alignSelf: "flex-start",
  },
});

export default RequestedTable;
